/* Calma Warenkorb (Schublade) + Gratis-Sortenwahl.
   Daten ausschliesslich ueber die Shopify Ajax Cart API:
   /cart.js lesen, /cart/add.js hinzufuegen, /cart/update.js fuer "Bundle entfernen"
   (mehrere Zeilen in einem Request, damit nie ein halbes Bundle stehen bleibt).
   Positionen eines Angebots tragen dieselbe Property _bundle, Gratis-Beutel zusaetzlich _gratis = "1".
   Den Preis macht der automatische Rabatt "1 + 1 gratis" (Kauf X, erhalte Y aus der Kollektion Sorten). */
(function () {
  "use strict";
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var dr = document.getElementById("cart-drawer");
  if (!dr) return;

  var body = document.getElementById("cart-body"),
      foot = document.getElementById("cart-foot"),
      ship = document.getElementById("cart-ship"),
      total = document.getElementById("cart-total"),
      err = document.getElementById("cart-err"),
      panel = dr.querySelector(".cart-panel");
  var FREE_SHIP = +dr.dataset.freeShipping || 3900,
      PORTIONS = +dr.dataset.portions || 15,
      EMPTY_URL = dr.dataset.emptyUrl || root + "collections/all";
  var currency = "EUR", cart = null, lastFocus = null;

  function money(cents) {
    try { return new Intl.NumberFormat("de-DE", { style: "currency", currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace(".", ",") + " €"; }
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function thumb(url) { return url ? url + (url.indexOf("?") < 0 ? "?" : "&") + "width=160" : ""; }
  function short(t) { return String(t || "").replace(/^Calma\s+/, ""); }

  function api(path, data) {
    var opt = data ? { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(data) }
                   : { headers: { "Accept": "application/json" } };
    return fetch(root + path, opt).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || "Fehler " + r.status); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function refresh() { return api("cart.js").then(function (c) { cart = c; currency = c.currency || currency; render(); return c; }); }

  /* ---------- Zaehler in der Navigation ---------- */
  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = n; el.hidden = !n; });
    document.querySelectorAll("[data-cart-open]").forEach(function (b) {
      b.setAttribute("aria-label", n ? "Warenkorb öffnen, " + n + (n === 1 ? " Beutel" : " Beutel") : "Warenkorb öffnen");
    });
  }

  /* ---------- Darstellung ---------- */
  function groups(items) {
    var out = [], byId = {};
    items.forEach(function (it) {
      var id = it.properties && it.properties._bundle;
      if (!id) { out.push({ id: null, lines: [it] }); return; }
      if (!byId[id]) { byId[id] = { id: id, lines: [] }; out.push(byId[id]); }
      byId[id].lines.push(it);
    });
    return out;
  }
  function isFree(it) { return !!(it.properties && it.properties._gratis === "1"); }

  function render() {
    if (!cart) return;
    setCount(cart.item_count);
    err.hidden = true;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Noch leer.</p><a class="btn ghost" href="' + esc(EMPTY_URL) + '">Sorte wählen</a></div>';
      foot.hidden = true;
      ship.textContent = "Versandkostenfrei ab " + money(FREE_SHIP);
      ship.classList.remove("is-ok");
      return;
    }
    body.innerHTML = groups(cart.items).map(function (g) {
      var paid = g.lines.filter(function (l) { return !isFree(l); }),
          free = g.lines.filter(isFree);
      var nPaid = paid.reduce(function (a, l) { return a + l.quantity; }, 0),
          nFree = free.reduce(function (a, l) { return a + l.quantity; }, 0);
      var keys = g.lines.map(function (l) { return l.key; }).join(",");
      var title = nFree ? nPaid + " + " + nFree + " gratis" : nPaid + (nPaid === 1 ? " Beutel" : " Beutel");
      var plan = g.lines[0].selling_plan_allocation ? "Abo" : "Einmalig";
      var row = function (l, gratis) {
        return '<li class="ci-line' + (gratis ? " ci-free" : "") + '">' +
          (l.image ? '<img src="' + esc(thumb(l.image)) + '" alt="" width="52" height="64" loading="lazy">' : '<span class="ci-ph"></span>') +
          '<span><b>' + esc(short(l.product_title)) + '</b><small>' + l.quantity + ' × ' + (gratis ? "gratis" : "bezahlt") + '</small></span>' +
          '<span class="ci-p">' + (gratis ? '<s>' + money(l.original_line_price) + '</s> Gratis' : money(l.original_line_price)) + '</span></li>';
      };
      return '<div class="ci">' +
        '<div class="ci-head"><b>' + esc(title) + '</b><span>' + plan + ' · ' + g.lines.reduce(function (a, l) { return a + l.quantity * (/30 Portionen/.test(l.product_title) ? 30 : PORTIONS); }, 0) + ' Abende</span>' +
        '<button type="button" class="ci-rm" data-rm="' + esc(keys) + '">Entfernen</button></div>' +
        '<ul>' + paid.map(function (l) { return row(l, false); }).join("") + free.map(function (l) { return row(l, true); }).join("") + '</ul>' +
      '</div>';
    }).join("");
    var dl = document.getElementById("cart-disc"); if (!dl) { dl = document.createElement("div"); dl.id = "cart-disc"; dl.className = "cart-disc"; foot.insertBefore(dl, foot.querySelector(".cart-sum")); } var dsum = {}, dord = []; var addD = function (t, a) { t = String(t || "Rabatt").split(":")[0]; if (!a) return; if (!(t in dsum)) { dsum[t] = 0; dord.push(t); } dsum[t] += a; }; cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { addD(a.discount_application && a.discount_application.title, a.amount); }); }); (cart.cart_level_discount_applications || []).forEach(function (d) { addD(d.title, d.total_allocated_amount); }); var dtot = (cart.original_total_price || 0) - cart.total_price; dl.innerHTML = dtot > 0 ? '<div><span>Zwischensumme</span><span>' + money(cart.original_total_price) + '</span></div>' + dord.map(function (t) { return '<div><span>' + esc(t) + '</span><span>−' + money(dsum[t]) + '</span></div>'; }).join("") + '<div class="is-save"><span>Du sparst</span><span>' + money(dtot) + '</span></div>' : ""; dl.hidden = !(dtot > 0); var up = document.getElementById("cart-up"); if (!up) { up = document.createElement("div"); up.id = "cart-up"; up.className = "cart-up"; foot.insertBefore(up, dl); } var TP = { 1: 3999, 2: 7998, 3: 10499 }, gs = groups(cart.items), ug = null; if (gs.length === 1 && gs[0].id && !gs[0].lines[0].selling_plan_allocation) { var gp = gs[0].lines.filter(function (l) { return !isFree(l); }), gf = gs[0].lines.filter(isFree), np = gp.reduce(function (a, l) { return a + l.quantity; }, 0), nf = gf.reduce(function (a, l) { return a + l.quantity; }, 0); if (gp.length && gf.length && np === nf && (np === 1 || np === 2)) ug = { id: gs[0].id, np: np, pv: gp[0].variant_id, fv: gf[gf.length - 1].variant_id }; } if (ug) { var nx = 3, ab = nx * 2 * PORTIONS; up.innerHTML = '<p><b>Upgrade auf ' + nx + ' + ' + nx + ' gratis</b><span>' + ab + ' Abende · nur ' + money(Math.round(TP[nx] / ab)) + ' pro Abend</span></p><button type="button" class="cart-up-btn" data-up="' + esc(ug.id) + '" data-pv="' + ug.pv + '" data-fv="' + ug.fv + '" data-add="' + (nx - ug.np) + '">+ ' + money(TP[nx] - TP[ug.np]) + '</button>'; up.hidden = false; } else { up.innerHTML = ""; up.hidden = true; } if (!dr.dataset.upb) { dr.dataset.upb = "1"; dr.addEventListener("click", function (e) { var b = e.target.closest("[data-up]"); if (!b) return; b.disabled = true; b.textContent = "…"; api("cart/add.js", { items: [{ id: +b.dataset.pv, quantity: +b.dataset.add || 1, properties: { _bundle: b.dataset.up } }, { id: +b.dataset.fv, quantity: +b.dataset.add || 1, properties: { _bundle: b.dataset.up, _gratis: "1" } }] }).then(function () { return refresh(); }).catch(function (x) { b.disabled = false; showErr("Upgrade hat nicht geklappt: " + x.message); }); }); } var pn = document.getElementById("cart-pn"); if (!pn) { pn = document.createElement("p"); pn.id = "cart-pn"; pn.className = "cart-pn"; var cs = foot.querySelector(".cart-sum"); cs.parentNode.insertBefore(pn, cs.nextSibling); } pn.textContent = "= " + money(Math.round(cart.total_price / (cart.items.reduce(function (a, l) { return a + l.quantity * (/30 Portionen/.test(l.product_title) ? 30 : PORTIONS); }, 0)))) + " pro Abend"; total.textContent = money(cart.total_price);
    foot.hidden = false;
    var rest = FREE_SHIP - cart.total_price;
    ship.textContent = rest <= 0 ? "✓ Versandkostenfrei" : "Noch " + money(rest) + " bis zum kostenlosen Versand";
    ship.classList.toggle("is-ok", rest <= 0);
  }

  function showErr(msg) { err.textContent = msg; err.hidden = false; foot.hidden = false; }

  /* ---------- Oeffnen / Schliessen ---------- */
  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }
  function open(trigger) {
    if (!dr.hidden && dr.classList.contains("is-open")) return;
    lastFocus = trigger && trigger.focus ? trigger : document.activeElement;
    dr.hidden = false;
    document.documentElement.classList.add("cart-lock");
    if (window.calmaLenis) window.calmaLenis.stop();
    requestAnimationFrame(function () { dr.classList.add("is-open"); });
    var x = dr.querySelector(".cart-x"); if (x) x.focus({ preventScroll: true });
  }
  function close() {
    if (dr.hidden) return;
    dr.classList.remove("is-open");
    document.documentElement.classList.remove("cart-lock");
    if (window.calmaLenis) window.calmaLenis.start();
    setTimeout(function () { dr.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.calmaCart = { open: function (trigger) { open(trigger); return refresh(); }, refresh: refresh };

  dr.addEventListener("click", function (e) {
    if (e.target.closest("[data-close]")) { close(); return; }
    var rm = e.target.closest("[data-rm]");
    if (rm) {
      var updates = {};
      rm.getAttribute("data-rm").split(",").forEach(function (k) { updates[k] = 0; });
      rm.disabled = true;
      api("cart/update.js", { updates: updates }).then(function (c) { cart = c; render(); })
        .catch(function (e) { rm.disabled = false; showErr("Konnte nicht entfernt werden: " + e.message); });
    }
  });
  document.addEventListener("keydown", function (e) {
    if (dr.hidden) return;
    if (e.key === "Escape") { e.preventDefault(); close(); return; }
    if (e.key === "Tab") {                       /* Fokus bleibt in der Schublade */
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-cart-open]");
    if (!b) return;
    e.preventDefault(); open(b); refresh();
  });

  refresh().catch(function () {});

  /* ---------- Produktseite: Gratis-Sortenwahl + In den Warenkorb ---------- */
  var form = document.getElementById("buy-form");
  if (!form) return;
  var fp = document.getElementById("freepick"),
      tpl = document.getElementById("fp-tpl"),
      submit = document.getElementById("buy-submit");
  var current = fp ? fp.dataset.current : null, picks = [];

  function selected() { return form.querySelector('input[data-menge]:checked'); }
  function freeCount() {
    var r = selected(); if (!r || r.dataset.free == null) return 0;
    return +r.dataset.free || 0;
  }
  function drawPicker() {
    if (!fp || !tpl) return;
    var f = freeCount();
    fp.hidden = !f;
    if (!f) return;
    var tiles = [].slice.call(tpl.content.querySelectorAll(".fp-o"));
    /* data-mix: neue Gratis-Beutel bekommen eine noch nicht gewaehlte Sorte (aktuelle zuerst) */
    var order = [current].concat(tiles.map(function (t) { return t.dataset.variant; }).filter(function (v) { return v !== current; }));
    while (picks.length < f) {
      var next = current;
      if (fp.hasAttribute("data-mix")) next = order.filter(function (v) { return picks.indexOf(v) < 0; })[0] || current;
      picks.push(next);
    }
    picks.length = f;
    var rows = picks.map(function (sel, i) {
      var row = document.createElement("div");
      row.className = "fp-row"; row.setAttribute("role", "radiogroup");
      row.setAttribute("aria-label", "Gratis-Beutel " + (i + 1));
      if (fp.hasAttribute("data-mix")) { var l = document.createElement("span"); l.className = "fp-n fp-l"; l.innerHTML = "<b>gratis</b>Beutel " + (i + 1); row.appendChild(l); }
      else if (f > 1) { var n = document.createElement("span"); n.className = "fp-n"; n.textContent = i + 1; row.appendChild(n); }
      tiles.forEach(function (t) {
        var b = t.cloneNode(true), on = b.dataset.variant === sel;
        b.dataset.i = i; b.classList.toggle("is-on", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
        b.tabIndex = on ? 0 : -1;
        row.appendChild(b);
      });
      return row;
    });
    var h = fp.querySelector(".fp-h");
    if (!h.hasAttribute("data-fixed")) h.textContent = f === 1 ? "Deine Gratis-Sorte" : "Deine " + f + " Gratis-Sorten";
    var wrap = fp.querySelector(".fp-rows"); wrap.innerHTML = ""; rows.forEach(function (r) { wrap.appendChild(r); });
  }
  if (fp) {
    fp.addEventListener("click", function (e) {
      var o = e.target.closest(".fp-o"); if (!o) return;
      picks[+o.dataset.i] = o.dataset.variant; drawPicker();
      var again = fp.querySelector('.fp-o[data-i="' + o.dataset.i + '"][data-variant="' + o.dataset.variant + '"]');
      if (again) again.focus();
    });
    fp.addEventListener("keydown", function (e) {     /* Pfeiltasten wie bei Radiobuttons */
      var o = e.target.closest(".fp-o"); if (!o) return;
      var d = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var row = [].slice.call(o.parentNode.querySelectorAll(".fp-o")), j = (row.indexOf(o) + d + row.length) % row.length;
      row[j].click();
    });
    form.addEventListener("change", function (e) { if (e.target.matches("input[data-menge]")) drawPicker(); });
    drawPicker();
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var r = selected(), btns = document.querySelectorAll("#buy-submit, [data-buy-submit]");
    var trigger = (e.submitter && e.submitter.focus) ? e.submitter : submit;
    var plan = (document.getElementById("selling-plan") || {}).value || "";
    var req;
    if (fp && r && r.dataset.paid) {
      var bundle = String(Date.now()), paid = +r.dataset.paid || 1;
      var items = [{ id: +current, quantity: paid, properties: { _bundle: bundle } }];
      if (plan) items[0].selling_plan = +plan;
      var counts = {};
      picks.slice(0, freeCount()).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      Object.keys(counts).forEach(function (v) { items.push({ id: +v, quantity: counts[v], properties: { _bundle: bundle, _gratis: "1" } }); });
      req = api("cart/add.js", { items: items });
    } else {
      /* Variantenmodus ohne Gratis-Wahl: Formular unveraendert senden */
      req = fetch(root + "cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message); return j; }); });
    }
    btns.forEach(function (b) { b.disabled = true; b.setAttribute("aria-busy", "true"); });
    req.then(function () { return refresh(); }).then(function () { open(trigger); })
      .catch(function (ex) { refresh().then(function () { open(trigger); showErr("Konnte nicht in den Warenkorb gelegt werden: " + ex.message); }); })
      .then(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute("aria-busy"); }); });
  });
})();
